import { render } from "./Gigs.vue?vue&type=template&id=3e7b2cb4&scoped=true"
import script from "./Gigs.vue?vue&type=script&lang=js"
export * from "./Gigs.vue?vue&type=script&lang=js"

import "./Gigs.vue?vue&type=style&index=0&id=3e7b2cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7b2cb4"]])

export default __exports__